module.exports = __webpack_public_path__ + "static/media/icon_calendar.a2ce302e.svg";